<h2 mat-dialog-title>{{ data.header }}</h2>
<mat-dialog-content>
  <div class="flex flex-col gap-1 max-w-md">
    <div class="flex flex-row gap-2 items-center">
      <p>{{ data.message }}</p>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="outlined" mat-dialog-close>
    {{ data.rejectLabel }}
  </button>
  <button matButton="filled" (click)="onAccept()">
    {{ data.acceptLabel }}
  </button>
</mat-dialog-actions>
